// 敏感密钥加密模块：必须最先引入，确保 axios 发送边界解密补丁早于所有 axios 实例创建前生效
import '@/utils/secretCrypto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import HeaderIndex from '@/components/HeaderIndex.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/style/index.less'
import '@/icons' // icon
import '@/permission' // permission control
// 统一注册器
import '@/init/command'

import global from './utils/global.js'
// 引入诊断工具
import './utils/diagnosisHelper'

// 模态框
import ImageModal from '@/components/ImageModal.vue'
import ToolBar from '@/components/ToolBar.vue'
import DiscussionBoard from '@/components/DiscussionBoard.vue'
import ElevaTor from '@/components/ElevaTor.vue'
import ShortCut from '@/components/ShortCut.vue'
import NaviGation from '@/components/NaviGation.vue'
import CallApplication from '@/components/CallApplication.vue'
import RightMenu from '@/components/RightMenu.vue'
import CanvasPad from '@/components/CanvasPad.vue'
import modelTemplate from '@/components/modelTemplate.vue'
import GpuMonitor from '@/components/GpuMonitor.vue'

Vue.prototype.$global = global

Vue.use(ElementUI)

Vue.config.productionTip = false

// 静默处理 ResizeObserver 循环通知错误
if (typeof window !== 'undefined') {
  // 方法1: 重写console.error过滤特定错误
  const originalError = console.error
  console.error = function(...args) {
    const message = args.join(' ')
    if (message.includes('ResizeObserver loop')) {
      return // 静默忽略
    }
    originalError.apply(console, args)
  }
  // 方法2: 全局错误拦截
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation()
      event.preventDefault()
      return false
    }
  }, true) // 使用捕获阶段
  // 方法3: 未捕获的Promise拒绝
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation()
      event.preventDefault()
      return false
    }
  }, true)
}

// 全局注册 HeaderIndex 组件
Vue.component('HeaderIndex', HeaderIndex)
Vue.component('ImageModal', ImageModal)
Vue.component('ToolBar', ToolBar)
Vue.component('DiscussionBoard', DiscussionBoard)
// 电梯组件
Vue.component('ElevaTor', ElevaTor)
Vue.component('ShortCut', ShortCut)
// 导航组件
Vue.component('NaviGation', NaviGation)
Vue.component('CallApplication', CallApplication)
Vue.component('RightMenu', RightMenu)
Vue.component('CanvasPad', CanvasPad)
Vue.component('modelTemplate', modelTemplate)
Vue.component('GpuMonitor', GpuMonitor)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
